import { render, staticRenderFns } from "./PazienteTerapiaViewFarmacoComponent.vue?vue&type=template&id=56ffab22&scoped=true"
import script from "./PazienteTerapiaViewFarmacoComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTerapiaViewFarmacoComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteTerapiaViewFarmacoComponent.vue?vue&type=style&index=0&id=56ffab22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffab22",
  null
  
)

export default component.exports